/*******************************************************************************
 * Dependency Imports
 ******************************************************************************/
// auth::api
import * as Api from './api'
// lodash - https://lodash.com/
import _ from 'lodash'

/*******************************************************************************
 * Services
 ******************************************************************************/

/*******************************************************************************
 * Configuration
 ******************************************************************************/

/*******************************************************************************
 * Transformer prototypes
 ******************************************************************************/

/*******************************************************************************
 * Private methods
 ******************************************************************************/

/**
 * general success
 *
 * @param {obj} data
 * @return {obj} le data
 */
const _onSuccess = data => {

    if( _.get( data, 'data.data' ) ) {
        return _.get( data, 'data.data' )
    }

    return data

}

/**
 * general fail
 *
 * @param {obj} error from a server
 * @return {obj} the error
 */
const _onFailed = error => new Promise(( resolve, reject ) => {

    let error_obj = error.hasOwnProperty( 'response' ) ? error.response : error

    let return_error = {
        ...error_obj.data,
        status: error_obj.status
    }

    reject( return_error )

})

/*******************************************************************************
 * Public methods
 ******************************************************************************/

/**
 * list the accounts
 * 
 * by default, will list all accounts visible to the requesting user
 *
 * @return {promise}
 */
export const list = params =>
    Api.list(params)
        .then( _onSuccess )
        .catch( _onFailed )

export const find = params =>
    Api.find(params)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * return a specific account by id
 * @param {int} account_id 
 * @returns 
 */
export const show = async (account_id = null) =>
    Api.show(account_id)
        .then( _onSuccess )
        .catch( _onFailed )

export const update = async (account_id = null, data) =>
    Api.update(account_id, data)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * get teh users associated to a given account
 * @param {int} account_id 
 * @param {arr} params 
 * @returns 
 */
export const users = async (account_id, params = []) =>
    Api.users(account_id, params)
        .then( _onSuccess )
        .catch( _onFailed )

/**
 * create a new account
 * @param data
 * @returns {Promise<obj>}
 */
export const create = async data =>
    Api.create(data)
        .then( _onSuccess )
        .catch( _onFailed )

export const locations = async account_id =>
    Api.locations(account_id)
        .then( _onSuccess )
        .catch( _onFailed )

export const updateLocation = async (account_id, location_id, data) =>
    Api.updateLocation(account_id, location_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const createLocation = async (account_id, data) =>
    Api.createLocation(account_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const assignLocation = async (account_id, location_id) =>
    Api.assignLocation(account_id, location_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const upsertLogo = async (account_id, data) =>
    Api.upsertLogo(account_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const listAliases = async (account_id) =>
    Api.listAliases(account_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const updateAlias = async (account_id, alias_id, data) =>
    Api.updateAlias(account_id, alias_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const deleteAlias = async (account_id, alias_id) =>
    Api.deleteAlias(account_id, alias_id)
        .then(_onSuccess)
        .catch(_onFailed)

export const createAlias = async (account_id, data) =>
    Api.createAlias(account_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const addSeller = async (account_id, data) =>
    Api.addSeller(account_id, data)
        .then(_onSuccess)
        .catch(_onFailed)

export const addBuyer = async (account_id, data) =>
    Api.addBuyer(account_id, data)
        .then(_onSuccess)
        .catch(_onFailed)